import './outline.scss';

document.addEventListener('click', function () {
   document.body.classList.add('no-outline');
});

document.addEventListener('keydown', function () {
    document.body.classList.remove('no-outline');
});